import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Checkbox, FormControlLabel, Stack, Tab, Tabs } from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { deCryptFun } from "../comman/CustomFunction";
import { filter } from "underscore";
import { getAlluserList } from "../../redux/action";

export default function UserLogFilter(props) {
  const {
    open,
    handleClose,
    filterValue,
    setFilterValue,
    filterInitial,
    applyFilterFun,
    getLogDetails,
    showCustomer,
    handleCancel,
    selectedcustomers,
    setSelectedCustomers,
  } = props;
  const dispatch = useDispatch();

  const [localFilterValue, setLocalFilterValue] = useState(filterValue);
  const scrollRef = useRef();
  const scrollPosition = useRef(0);
  const scrollRefUser = useRef();
  const scrollRefCustomer = useRef();
  const scrollPositionUser = useRef(0);
  const scrollPositionCustomer = useRef(0);
  console.log(localFilterValue, "kdddddddddddddddddddddddk");
  console.log(selectedcustomers, "selectedcustomerskkkkkkkkkkk");
  const handleScroll = () => {
    scrollPosition.current = scrollRef.current.scrollTop;
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollPosition.current;
    }
  });

  const handleScrolluser = () => {
    console.log(
      "user scroll",
      scrollPositionUser.current,
      scrollRefUser.current.scrollTop
    );
    scrollPositionUser.current = scrollRefUser.current.scrollTop;
  };
  const handleScrollCustomer = () => {
    console.log(
      scrollPositionCustomer.current,
      scrollRefCustomer.current.scrollTop
    );
    scrollPositionCustomer.current = scrollRefCustomer.current.scrollTop;
  };

  useEffect(() => {
    if (scrollRefUser.current) {
      scrollRefUser.current.scrollTop = scrollPositionUser.current;
    }
  });

  useEffect(() => {
    if (scrollRefCustomer.current) {
      scrollRefCustomer.current.scrollTop = scrollPositionCustomer.current;
    }
  });
  const { userId, logTypeId, dateRange, customerId } = localFilterValue;
  // const formattedCustomerId = customerId&&customerId.map(String); // If working with strings
  let formattedCustomerId = Array.isArray(customerId)
    ? customerId
    : typeof customerId === "string"
    ? customerId.split(",").map(Number)
    : typeof customerId === "number"
    ? [customerId]
    : [];

  console.log("customer id", customerId);
  const dateVal = [
    { id: 1, value: "All" },
    { id: 30, value: "Last 30 days" },
    { id: 60, value: "Last 60 days" },
    { id: 90, value: "Last 90 days" },
    { id: 180, value: "Last 180 days" },
  ];

  let userListSel = [];
  userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const typeListSel = deCryptFun(useSelector((s) => s.AllTypeReducer));
  console.log("types", typeListSel);
  const customerListSel = deCryptFun(
    useSelector((s) => s.AllCustomerListReducer)
  );
  // const customerList = customerListSel ? JSON.parse(customerListSel).data : [];

  const resetFun = () => {
    console.log("filterIni", filterInitial);
    setLocalFilterValue({ ...filterInitial, userId: [], customerId: [] });
  };

  console.log("local", localFilterValue);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleUserSelect = (e) => {
    const val = e.currentTarget.dataset.userid;
    console.log(e.target, "e.currentTarget");

    // Normalize localFilterValue.userId to an array
    let temp = Array.isArray(localFilterValue.userId)
      ? localFilterValue.userId
      : typeof localFilterValue.userId === "string"
      ? localFilterValue.userId.split(",")
      : []; // Default to an empty array if it's neither a string nor an array

    console.log(temp, "Selected User ID:", localFilterValue.userId);

    if (e.target.checked) {
      // If the ID is not in the array, add it
      if (!temp.includes(val)) {
        temp.push(val);
      }
    } else {
      // If the ID is in the array, remove it
      temp = temp.filter((r) => r !== val);
    }

    // Convert the array back to a comma-separated string
    const updatedUserId = temp.join(",");

    // Update the state with the new value
    setLocalFilterValue({ ...localFilterValue, userId: updatedUserId });
  };
  const handleCustomerSelect = (e) => {
    const val = e.currentTarget.dataset.userid;
    console.log(e.target, "e.currentTarget", val);

    // Normalize localFilterValue.userId to an array
    let temp = Array.isArray(localFilterValue.customerId)
      ? localFilterValue.customerId
      : typeof localFilterValue.customerId === "string"
      ? localFilterValue.customerId.split(",")
      : []; // Default to an empty array if it's neither a string nor an array

    const filteredValues =
      Array.isArray(localFilterValue.customerId) &&
      localFilterValue.customerId.map(String).includes(val.toString())
        ? true
        : false;

    console.log(filteredValues, "filteredValues");

    if (e.target.checked && !filteredValues) {
      // If the ID is not in the array, add it
      if (!temp.includes(val)) {
        temp.push(val);
      }
    } else {
      // If the ID is in the array, remove it
      temp = temp.filter((r) => r != val);
    }

    // Convert the array back to a comma-separated string
    const updatedUserId = temp.join(",");

    // Update the state with the new value
    setLocalFilterValue({ ...localFilterValue, customerId: updatedUserId });
  };

  const handleTypeSelect = (e) => {
    const val = parseInt(e.currentTarget.dataset.typeid);
    let temp = [...logTypeId];
    console.log(val,'ahskjfhcfyeoiuyiueyhfuyeiuyfh')

    if (temp.includes(val)) {
      temp = temp.filter((r) => r !== val);
    } else {
      temp.push(val);
    }

    setLocalFilterValue({ ...localFilterValue, logTypeId: temp });
  };

  const handleDateRange = (e) => {
    const val = parseInt(e.currentTarget.dataset.drange);
    setLocalFilterValue({ ...localFilterValue, dateRange: val });
  };

  // Apply filter and close dialog
  const handleApplyFilter = () => {
    console.log(localFilterValue, "locallalal");
    setFilterValue(localFilterValue);
    applyFilterFun(
      localFilterValue.userId,
      logTypeId,
      localFilterValue.customerId
    );
    handleClose();
  };

  // Reset local state on dialog open
  useEffect(() => {
    dispatch(getAlluserList());
    if (open) {
      setLocalFilterValue(filterValue);
    }
  }, [open, filterValue]);

  return (
    <>
      <Dialog
        className="user-filter-popup"
        sx={{ width: "100%" }}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "16px 20px", borderBottom: "1px solid #EDEDED" }}
          direction={{ xs: "column", sm: "row", md: "row" }}
          alignItems={{ xs: "flex-start", sm: "center", md: "center" }}
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={
              <span className="material-symbols-outlined">history</span>
            }
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box
          sx={{
            bgcolor: "background.paper",
            display: { xs: "unset", md: "flex" },
            borderBottom: "1px solid #EDEDED",
          }}
        >
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: "#EDEDED",
              overflow: "unset",
            }}
          >
            <Tab icon={<PersonIconSvg />} iconPosition="start" label="Users" />
            {showCustomer == "yes" && (
              <Tab
                icon={<PersonIconSvg />}
                iconPosition="start"
                label="Customers"
              />
            )}
            <Tab icon={<ListIconSvg />} iconPosition="start" label="Type" />
            <Tab
              icon={<DateIconSvg />}
              iconPosition="start"
              label="Date Range"
            />
          </Tabs>
          {showCustomer == "yes" ? (
            <>
              <TabPanel value={value} index={0}>
                <Box
                  ref={scrollRefUser}
                  onScroll={handleScrolluser}
                  className="user-tab-panel filter-tab-panel"
                >
                  {userListSel &&
                    JSON.parse(userListSel).data
                    .filter((item)=> item?.AdminApproved == 1)
                    .map((rec, i) => {
                      console.log(rec, "lopKSJDDN");
                      return (
                        <FormControlLabel
                          key={`user${i}`}
                          className="checkbox"
                          control={
                            <Checkbox
                              sx={{ color: "gray" }}
                              data-userid={rec.UserId}
                              onClick={handleUserSelect}
                              checked={userId.includes(rec.UserId)}
                            />
                          }
                          label={`${rec.FirstName} ${rec.LastName} (${rec.Email})`}
                        />
                      );
                    })}
                </Box>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Box
                  ref={scrollRefCustomer}
                  onScroll={handleScrollCustomer}
                  className="user-tab-panel filter-tab-panel"
                >
                  {customerListSel &&
                    JSON.parse(customerListSel).data.map((rec, i) => {
                      console.log(rec, "cutomer chk", customerId);
                      return (
                        <FormControlLabel
                          key={`customer${i}`}
                          className="checkbox"
                          control={
                            <Checkbox
                              sx={{ color: "gray" }}
                              data-userid={rec.UserId}
                              onClick={handleCustomerSelect}
                              checked={formattedCustomerId.includes(
                                Number(rec.UserId)
                              )}
                              // checked={
                              //   Array.isArray(customerId)
                              //     ? customerId.includes(rec.UserId)
                              //     : customerId === rec.UserId
                              // }
                            />
                          }
                          label={`${rec.Name} (${rec.ContactEmail})`}
                        />
                      );
                    })}
                </Box>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Box
                  ref={scrollRef}
                  onScroll={handleScroll}
                  className="type-tab-panel filter-tab-panel"
                >
                  {typeListSel &&
                    JSON.parse(typeListSel).data.map((r, i) => {
                      return (
                        <FormControlLabel
                          key={`type${i}`}
                          className="checkbox"
                          control={
                            <Checkbox
                              sx={{ color: "gray" }}
                              data-typeid={r.LogTypeID}
                              checked={logTypeId.includes(
                                parseInt(r.LogTypeID)
                              )}
                              onClick={handleTypeSelect}
                            />
                          }
                          label={r.LogTypeDescription}
                        />
                      );
                    })}
                </Box>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Box className="user-tab-panel filter-tab-panel">
                  {dateVal.map((r, i) => {
                    return (
                      <FormControlLabel
                        key={`date${i}`}
                        className="checkbox"
                        control={
                          <Checkbox
                            sx={{ color: "gray" }}
                            checked={dateRange === r.id}
                            onClick={handleDateRange}
                            data-drange={r.id}
                          />
                        }
                        label={r.value}
                      />
                    );
                  })}
                </Box>
              </TabPanel>
            </>
          ) : (
            <>
              <TabPanel value={value} index={0}>
                <Box
                  ref={scrollRefUser}
                  onScroll={handleScrolluser}
                  className="user-tab-panel filter-tab-panel"
                >
                  {userListSel &&
                    JSON.parse(userListSel).data.map((rec, i) => {
                      console.log(rec, "lopKSJDDN");
                      return (
                        <FormControlLabel
                          key={`user${i}`}
                          className="checkbox"
                          control={
                            <Checkbox
                              sx={{ color: "gray" }}
                              data-userid={rec.UserId}
                              onClick={handleUserSelect}
                              checked={userId.includes(rec.UserId)}
                            />
                          }
                          label={`${rec.FirstName} ${rec.LastName} (${rec.Email})`}
                        />
                      );
                    })}
                </Box>
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Box
                  ref={scrollRef}
                  onScroll={handleScroll}
                  className="type-tab-panel filter-tab-panel"
                >
                  {typeListSel &&
                    JSON.parse(typeListSel).data.map((r, i) => {
                      return (
                        <FormControlLabel
                          key={`type${i}`}
                          className="checkbox"
                          control={
                            <Checkbox
                              sx={{ color: "gray" }}
                              data-typeid={r.LogTypeID}
                              checked={logTypeId.includes(
                                parseInt(r.LogTypeID)
                              )}
                              onClick={handleTypeSelect}
                            />
                          }
                          label={r.LogTypeDescription}
                        />
                      );
                    })}
                </Box>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Box className="user-tab-panel filter-tab-panel">
                  {dateVal.map((r, i) => {
                    return (
                      <FormControlLabel
                        key={`date${i}`}
                        className="checkbox"
                        control={
                          <Checkbox
                            sx={{ color: "gray" }}
                            checked={dateRange === r.id}
                            onClick={handleDateRange}
                            data-drange={r.id}
                          />
                        }
                        label={r.value}
                      />
                    );
                  })}
                </Box>
              </TabPanel>
            </>
          )}
        </Box>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            ml: { xs: "0px", md: "240px" },
            p: "20px",
          }}
        >
          <Button className="filter-btn" onClick={handleApplyFilter}>
            Apply Filter
          </Button>
          <Button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
